import { createReducer } from '@reduxjs/toolkit';
import { getSocialLinks } from '../actions/socialLinks';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getSocialLinks.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
